/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DelegatesPage_manager = {
    readonly company: {
        readonly name: string;
        readonly numDelegates: number;
        readonly simulatorReportPreviewURL: string | null;
        readonly simulatorCompliance: {
            readonly activeUsers: number;
        };
        readonly certificatesStatus: {
            readonly secondaryCategoryStatuses: ReadonlyArray<{
                readonly secondaryCategory: {
                    readonly uuid: string | null;
                    readonly name: string;
                } | null;
            }>;
        };
    };
    readonly " $refType": "DelegatesPage_manager";
};
export type DelegatesPage_manager$data = DelegatesPage_manager;
export type DelegatesPage_manager$key = {
    readonly " $data"?: DelegatesPage_manager$data;
    readonly " $fragmentRefs": FragmentRefs<"DelegatesPage_manager">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "DelegatesPage_manager",
        "type": "Manager",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "company",
                "storageKey": null,
                "args": null,
                "concreteType": "Company",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "numDelegates",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "simulatorReportPreviewURL",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "simulatorCompliance",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SimulatorCompliance",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "activeUsers",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "certificatesStatus",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CompanyCertificateStatus",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "secondaryCategoryStatuses",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SecondaryCategoryCertificateStatus",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "secondaryCategory",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "SecondaryCategory",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "uuid",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            (v0 /*: any*/)
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '9af7d49999d1a6395d1b1303394a8db5';
export default node;
